export default __webpack_public_path__ + "static/media/op-manager-report-dark.daf94ced.svg";